import {
  createClearType,
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

const CRM_EVENT_SCOPE = 'CRM_EVENT_SCOPE';
export const CRM_EVENT = createSubmitType(CRM_EVENT_SCOPE);
export const CRM_EVENT_LOADING = createLoadingType(CRM_EVENT_SCOPE);
export const CRM_EVENT_SUCCESS = createSuccessType(CRM_EVENT_SCOPE);
export const CRM_EVENT_ERROR = createErrorType(CRM_EVENT_SCOPE);
export const CRM_EVENT_EMPTY = createClearType(CRM_EVENT_SCOPE);

const CRM_SAVE_EXIT_EVENT_SCOPE = 'CRM_SAVE_EXIT_EVENT_SCOPE';
export const CRM_SAVE_EXIT_EVENT = createSubmitType(CRM_SAVE_EXIT_EVENT_SCOPE);
export const CRM_SAVE_EXIT_EVENT_LOADING = createLoadingType(
  CRM_SAVE_EXIT_EVENT_SCOPE,
);
export const CRM_SAVE_EXIT_EVENT_SUCCESS = createSuccessType(
  CRM_SAVE_EXIT_EVENT_SCOPE,
);
export const CRM_SAVE_EXIT_EVENT_ERROR = createErrorType(
  CRM_SAVE_EXIT_EVENT_SCOPE,
);
export const CRM_SAVE_EXIT_EVENT_EMPTY = createClearType(
  CRM_SAVE_EXIT_EVENT_SCOPE,
);
